import script from "./WeiXinCode.vue?vue&type=script&setup=true&lang=js"
export * from "./WeiXinCode.vue?vue&type=script&setup=true&lang=js"

import "./WeiXinCode.vue?vue&type=style&index=0&id=e88214ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e88214ae"]])

export default __exports__